import { useState } from "react";
import { FileArchive, FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { safeName } from "../../lib/brand";
import { saveBlob } from "../../lib/files";
import { isAdmin, useAuth } from "../../context/AuthContext";

const MSG_EMPTY = "Este expediente no tiene archivos";

export const ClientDownloads = ({ client }) => {
  const [busy, setBusy] = useState("");
  const { user } = useAuth();
  const hasFiles = (client.expediente.files || []).length > 0;
  const base = `Reporte - ${safeName(client.name)} - ${client.borrower_id}`;

  const download = async (kind) => {
    setBusy(kind);
    const path = kind === "pdf" ? "report.pdf" : "expediente.zip";
    try {
      const r = await api.get(`/clients/${encodeURIComponent(client.borrower_id)}/${path}`, { responseType: "blob" });
      saveBlob(r.data, kind === "pdf" ? `${base}.pdf` : `Expediente - ${safeName(client.name)} - ${client.borrower_id}.zip`);
    } catch {
      toast.error("No se pudo generar la descarga, intenta de nuevo");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="client-downloads">
      <button type="button" onClick={() => download("pdf")} disabled={!!busy} className="tr-btn-light px-4 py-2 text-sm disabled:cursor-wait disabled:opacity-60" data-testid="download-report-button">
        {busy === "pdf" ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />}
        {busy === "pdf" ? "Generando reporte…" : "Descargar reporte (PDF)"}
      </button>
      {isAdmin(user) && <span title={hasFiles ? undefined : MSG_EMPTY} className="inline-flex" data-testid="download-zip-wrapper">
        <button
          type="button"
          onClick={() => download("zip")}
          disabled={!hasFiles || !!busy}
          className="tr-btn-light px-4 py-2 text-sm disabled:cursor-not-allowed disabled:opacity-50"
          data-testid="download-zip-button"
        >
          {busy === "zip" ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileArchive className="h-4 w-4" />}
          {busy === "zip" ? "Preparando expediente…" : "Descargar expediente completo"}
        </button>
      </span>}
    </div>
  );
};
